module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "-5px",
      "width": "1000px"
    },
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "inline": true,
      "label": "left",
      "label-width": "60px",
      "size": "mini"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("委托单")])])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "text-align": "left",
      "margin": "-5px"
    }
  }, [_c('strong', [_vm._v("委托方")])])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin": "-5px"
    }
  }, [_c('strong', [_vm._v("编号")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "410px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.clientName),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientName", $$v)
      },
      expression: "form.clientName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.clientContacts),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientContacts", $$v)
      },
      expression: "form.clientContacts"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.clientPhone),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientPhone", $$v)
      },
      expression: "form.clientPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址 "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "410px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.clientAddr),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientAddr", $$v)
      },
      expression: "form.clientAddr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.clientMail),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientMail", $$v)
      },
      expression: "form.clientMail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "传真"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    model: {
      value: (_vm.form.clientFax),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientFax", $$v)
      },
      expression: "form.clientFax"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left",
      "margin": "-3px"
    }
  }, [_c('strong', [_vm._v("样品信息")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left",
      "margin": "-1px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "data": _vm.tableData1,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "100",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "样品名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "specs",
      "label": "型号规格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trademark",
      "label": "商标"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteRow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left",
      "margin": "-3px"
    }
  }, [_c('strong', [_vm._v("检验要求")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检验依据",
      "label-width": "78px",
      "prop": "basis"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "270px"
    },
    model: {
      value: (_vm.form.basis),
      callback: function($$v) {
        _vm.$set(_vm.form, "basis", $$v)
      },
      expression: "form.basis"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检验项目",
      "label-width": "78px",
      "prop": "items"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "270px"
    },
    model: {
      value: (_vm.form.items),
      callback: function($$v) {
        _vm.$set(_vm.form, "items", $$v)
      },
      expression: "form.items"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "该检验是否与诉讼有关",
      "label-width": "160px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.lawsuit),
      callback: function($$v) {
        _vm.$set(_vm.form, "lawsuit", $$v)
      },
      expression: "form.lawsuit"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.form.lawsuit),
      callback: function($$v) {
        _vm.$set(_vm.form, "lawsuit", $$v)
      },
      expression: "form.lawsuit"
    }
  }, [_vm._v("是")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left",
      "margin": "-3px"
    }
  }, [_c('strong', [_vm._v("报告要求")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "报告版本",
      "label-width": "70px"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": function (val) { return _vm.checkinlist(val); }
    },
    model: {
      value: (_vm.form.reportType),
      callback: function($$v) {
        _vm.$set(_vm.form, "reportType", $$v)
      },
      expression: "form.reportType"
    }
  }, _vm._l((_vm.reportTypes), function(report) {
    return _c('el-checkbox', {
      key: report,
      attrs: {
        "label": report
      }
    }, [_vm._v(_vm._s(report))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "报告形式",
      "label-width": "70px"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": function (val) { return _vm.checkinlist1(val); }
    },
    model: {
      value: (_vm.form.reportForm),
      callback: function($$v) {
        _vm.$set(_vm.form, "reportForm", $$v)
      },
      expression: "form.reportForm"
    }
  }, _vm._l((_vm.forms), function(form1) {
    return _c('el-checkbox', {
      key: form1.value,
      attrs: {
        "label": form1.value
      }
    }, [_vm._v(_vm._s(form1.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "如对报告有其他要求，请说明",
      "label-width": "195px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "770px"
    },
    model: {
      value: (_vm.form.reportRemark),
      callback: function($$v) {
        _vm.$set(_vm.form, "reportRemark", $$v)
      },
      expression: "form.reportRemark"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left",
      "margin": "-5px"
    }
  }, [_c('strong', [_vm._v("样品处理")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.sampleHandle),
      callback: function($$v) {
        _vm.$set(_vm.form, "sampleHandle", $$v)
      },
      expression: "form.sampleHandle"
    }
  }, [_vm._v("邮寄")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.form.sampleHandle),
      callback: function($$v) {
        _vm.$set(_vm.form, "sampleHandle", $$v)
      },
      expression: "form.sampleHandle"
    }
  }, [_vm._v("销毁")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.form.sampleHandle),
      callback: function($$v) {
        _vm.$set(_vm.form, "sampleHandle", $$v)
      },
      expression: "form.sampleHandle"
    }
  }, [_vm._v("自取")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.form.sampleHandle),
      callback: function($$v) {
        _vm.$set(_vm.form, "sampleHandle", $$v)
      },
      expression: "form.sampleHandle"
    }
  }, [_vm._v("保管")])], 1)], 1), _vm._v(" "), (false) ? _c('el-form-item', {
    attrs: {
      "label": "被委托部门"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    model: {
      value: (_vm.form.clientDept),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientDept", $$v)
      },
      expression: "form.clientDept"
    }
  })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('el-form-item', {
    attrs: {
      "label": "下委托单人"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    model: {
      value: (_vm.form.userId),
      callback: function($$v) {
        _vm.$set(_vm.form, "userId", $$v)
      },
      expression: "form.userId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('el-form-item', {
    attrs: {
      "label": "下委托公司"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    model: {
      value: (_vm.form.enterpriseId),
      callback: function($$v) {
        _vm.$set(_vm.form, "enterpriseId", $$v)
      },
      expression: "form.enterpriseId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('el-form-item', {
    attrs: {
      "label": "外网委托标识"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    model: {
      value: (_vm.form.isextranet),
      callback: function($$v) {
        _vm.$set(_vm.form, "isextranet", $$v)
      },
      expression: "form.isextranet"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v("确认下单")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.formtitle,
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "subData",
    attrs: {
      "model": _vm.obj,
      "label-width": "90px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "样品名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入样品名称"
    },
    model: {
      value: (_vm.obj.name),
      callback: function($$v) {
        _vm.$set(_vm.obj, "name", $$v)
      },
      expression: "obj.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "规格型号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入规格型号"
    },
    model: {
      value: (_vm.obj.specs),
      callback: function($$v) {
        _vm.$set(_vm.obj, "specs", $$v)
      },
      expression: "obj.specs"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商标"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商标"
    },
    model: {
      value: (_vm.obj.trademark),
      callback: function($$v) {
        _vm.$set(_vm.obj, "trademark", $$v)
      },
      expression: "obj.trademark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数量"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入数量"
    },
    model: {
      value: (_vm.obj.number),
      callback: function($$v) {
        _vm.$set(_vm.obj, "number", $$v)
      },
      expression: "obj.number"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.open()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-449e0a78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/consignation/placeOrder.vue
// module id = 1202
// module chunks = 10